'use client';

interface FilterBarProps {
  filters: string[];
  activeFilter: string;
  onFilterChange: (f: string) => void;
}

export default function FilterBar({ filters, activeFilter, onFilterChange }: FilterBarProps) {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {filters.map((filter) => (
        <button
          key={filter}
          onClick={() => onFilterChange(filter)}
          className={`px-3.5 py-1.5 text-[12px] font-['IBM_Plex_Sans',system-ui,sans-serif] border border-[#D4D4D4] transition-all duration-150 ${
            activeFilter === filter
              ? 'bg-[#1A1A1A] text-white border-[#1A1A1A]'
              : 'bg-white text-[#2D2D2D] hover:bg-[#F5F4F0]'
          }`}
        >
          {filter}
        </button>
      ))}
    </div>
  );
}
